import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const getRoster = new SchemaValidator(
	Type.Object({
		entries: Type.Array(
			Type.Object({
				lti1p3AccountId: Type.String(),
				userId: Type.String(),
				secondaryLmsUserId: Type.Union([Type.String(), Type.Null()]),
				email: Type.Union([Type.String(), Type.Null()]),
				firstName: Type.Union([Type.String(), Type.Null()]),
				lastName: Type.Union([Type.String(), Type.Null()]),
				role: Type.String(),
				locked: Type.Boolean(),
			}),
		),
		currentPage: Type.Number(),
		totalElements: Type.Number(),
		totalPages: Type.Number(),
	}),
);

const getRosterStatistics = new SchemaValidator(
	Type.Object({
		TOTAL: Type.Number(),
		ADMIN: Type.Number(),
		INSTRUCTOR: Type.Number(),
		STUDENT: Type.Number(),
	}),
);

const updateRoster = new SchemaValidator(
	Type.Object({
		lti1p3AccountId: Type.String(),
		userId: Type.String(),
		role: Type.String(),
		locked: Type.Boolean(),
	}),
);

export default {
	getRoster,
	getRosterStatistics,
	updateRoster,
};
